import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import styled from "styled-components";
import { AGI_GRID_COLUMNS } from "./agiList.styled";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: ${Spacing.sm}px;
`;

export const PayoutRowGrid = styled.div<{ $isLastRow: boolean }>`
  display: grid;
  grid-template-columns: ${AGI_GRID_COLUMNS};
  column-gap: 10px;
  padding-bottom: ${(props) => (props.$isLastRow ? "0" : "12px")};
  border-bottom: ${(props) =>
    props.$isLastRow ? "none" : `1px solid ${ColorV2.Blue6}`};
`;
